import React from 'react'
// hooks
import { useSubscription } from '@apollo/client/react'
import { useCurrentUser } from 'hooks/useCurrentUser'
// graphql
import { APP_NOTIFICATION } from 'graphql/notifications/subscriptions'
// types
import { INotification } from 'types/graphql'
import { RiskNotificationType } from 'types/risk'

export const usePlanItemNotification = (entityId: string | undefined, refetch: () => void) => {
  const user = useCurrentUser()

  const { data: subscriptionData } = useSubscription<{ notification: INotification }>(APP_NOTIFICATION, {
    shouldResubscribe: true,
    skip: !entityId,
    variables: { eventType: `${entityId}:${user.company.domainName}` }
  })

  React.useEffect(() => {
    if (!subscriptionData) return

    const notification = subscriptionData?.notification?.payload

    if (notification?.notificationType === RiskNotificationType.StrategySetField) {
      refetch()
    }
  }, [subscriptionData])
}
